<template>
    <div>
				<p class="search_service">Поиск услуги</p>
        <div class="search__wrapper" style="margin-bottom: 30px;">
            <Input
										class="search_element"
                    v-model:value="service_name"
                    placeholder="Название услуги"
                    style="max-width: 200px"
            ></Input>

<!--            <Input-->
<!--                    class="search_element"-->
<!--                    v-model:value="service_article"-->
<!--                    placeholder="Артикул"-->
<!--                    style="max-width: 200px"-->
<!--            ></Input>-->

            <Button :disabled="loading" @click="getFilteredTree" class="search_element">Найти</Button>
            <Button :disabled="loading" @click="reset" class="search_element">Сброс</Button>
        </div>

        <template v-if="!loading">
            <DirectoryTree
                    v-model:expandedKeys="expandedKeys"
                    v-model:selectedKeys="selectedKeys"
                    v-model:checkedKeys="checkedKeys"
                    :tree-data="filtered_tree"
                    :field-names="fieldNames"
            >
                <template #title="record">
<!--                    <template v-if="!record.child">{{ record.data.data.code }}</template>-->
                    {{ record.name }}
                    <template v-if="!record.child">(Цена: {{ parseInt(record.data.data.price) }})</template>
                </template>
            </DirectoryTree>
        </template>
        <template v-else>
						<div style="margin-top: 30px;">
                <Spin></Spin>
						</div>
        </template>

    </div>
</template>

<script setup>
import {ref} from "vue";
import {DirectoryTree, Input, Button, Spin} from "ant-design-vue"
import axios from "axios";

const expandedKeys = ref([]);
const selectedKeys = ref([]);
const checkedKeys = ref([]);

let service_name = ref('');
let service_article = ref('');
let loading = ref(false);

const fieldNames = {
  children: 'child',
  title: 'name',
};

let tree_data = ref([]);
let source_tree_data = ref([]);
let filtered_tree = ref([]);

async function getFilteredTree() {
  loading.value = true;
  const res = recursiveFilter(tree_data.value);
  filtered_tree.value = res;
  loading.value = false;
}

function reset() {
  loading.value = true;
  service_name.value = '';
  service_article.value = '';

  getData();
  // nextTick().then(() => {
  //   tree_data.value = structuredClone(source_tree_data.value);
  //   getFilteredTree();
	// })
}

function recursiveFilterClearEmpty(data) {
  const res = data.map((el) => {
    if (el.child && el.child.length > 0) {
      el.child = recursiveFilterClearEmpty(el.child)
      return el;
    } else if (el.child && el.child.length === 0 && !el.isLeaf) {
      return undefined
    } else {
      return el;
    }
  }).filter(element => element !== undefined);
  return res;
}

function recursiveFilter(data) {
  let res = data.map((el) => {
    if (el.child && el.child.length > 0) {
      el.child = recursiveFilter(el.child)
      return el;
    } else {
      if (service_name.value.length > 0 || service_article.value.length > 0) {
        let need_return = false;

        if (service_name.value.length > 0) {
          if (el.name.toLowerCase().includes(service_name.value.toLowerCase())) {
            need_return = true;
          }
        }

        if (service_article.value.length > 0) {
          if (el?.data?.code && el.data.code.toLowerCase().includes(service_article.value.toLowerCase())) {
            need_return = true;
          } else {
            need_return = false;
					}
        }

        if (need_return) {
          return el;
        } else {
          return undefined;
        }
      } else {
        return el;
      }
    }
  }).filter(element => element !== undefined);
  res = recursiveFilterClearEmpty(res);
  return res;
}

async function getData() {
  loading.value = true;
  const response = await axios.get('https://medestet-tambov.ru/wp-admin/admin-ajax.php?action=get_service_prices_tree');
  const source = structuredClone(response.data);

  source_tree_data.value = source;
  tree_data.value = response.data;

  getFilteredTree();
}

getData();


</script>

<style>
:where(.css-dev-only-do-not-override-19yxfbp).ant-tree.ant-tree-block-node .ant-tree-list-holder-inner .ant-tree-node-content-wrapper {
    flex: none;
}
.search_element:not(:first-child) {
    margin-left: 20px;
}
</style>